import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import Footer from '../components/layout/Footer';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Hero Header Banner */}
      <div style={{ backgroundColor: '#0f172a', color: '#ffffff', padding: '32px 24px 48px', position: 'relative' }}>
        <div style={{ maxWidth: '960px', margin: '0 auto 16px auto', display: 'flex', alignItems: 'center' }}>
          <button
            onClick={() => window.history.length > 1 ? navigate(-1) : navigate('/')}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 16px',
              borderRadius: '20px',
              backgroundColor: 'rgba(255, 255, 255, 0.12)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: '#ffffff',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              backdropFilter: 'blur(8px)',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.25)')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.12)')}
          >
            <FiArrowLeft size={18} />
            Back
          </button>
        </div>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ fontSize: '32px', fontWeight: '900', margin: '0 0 12px 0', letterSpacing: '-0.5px' }}>
            Privacy Policy
          </h1>
          <p style={{ fontSize: '15px', color: '#94a3b8', margin: 0, maxWidth: '600px', marginLeft: 'auto', marginRight: 'auto' }}>
            HoneyCool values your privacy. Learn how we collect, protect, and use your personal information.
          </p>
        </div>
      </div>

      {/* Main Legal Content */}
      <div style={{ maxWidth: '960px', margin: '36px auto', padding: '0 24px', flex: 1, width: '100%', boxSizing: 'border-box' }}>
        <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '36px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)', textAlign: 'left' }}>
          
          <div style={{ marginBottom: '28px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', marginTop: 0, marginBottom: '12px', borderBottom: '2px solid #38bdf8', paddingBottom: '8px', display: 'inline-block' }}>
              1. Information We Collect
            </h2>
            <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: '0 0 12px 0' }}>
              When you create an account, browse products, or complete orders on <strong>HoneyCool</strong>, we collect essential information required to fulfill your orders and deliver customer service:
            </p>
            <ul style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: 0, paddingLeft: '20px' }}>
              <li><strong>Personal Identity:</strong> Full Name, Email Address, Contact Number.</li>
              <li><strong>Shipping & Billing Details:</strong> Delivery Address, Pin Code, Alternate Phone Number, GSTIN (for tax invoicing).</li>
              <li><strong>Technical Data:</strong> IP address, device information, and browser session tokens for secure login.</li>
            </ul>
          </div>

          <div style={{ marginBottom: '28px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', marginTop: 0, marginBottom: '12px', borderBottom: '2px solid #38bdf8', paddingBottom: '8px', display: 'inline-block' }}>
              2. How We Use Your Data
            </h2>
            <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: 0 }}>
              Your data is used strictly to process orders, generate 18% GST tax invoices, dispatch shipments via courier partners, send real-time order tracking updates, and maintain account security. We do <strong>not</strong> sell or rent your personal information to third-party advertisers.
            </p>
          </div>

          <div style={{ marginBottom: '28px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', marginTop: 0, marginBottom: '12px', borderBottom: '2px solid #38bdf8', paddingBottom: '8px', display: 'inline-block' }}>
              3. Payment & Data Security
            </h2>
            <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: 0 }}>
              All online payment transactions are processed over encrypted 256-bit SSL connections via PCI-DSS compliant payment gateways. HoneyCool does not store sensitive credit card or net-banking credentials on our servers.
            </p>
          </div>

          <div style={{ marginBottom: '28px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', marginTop: 0, marginBottom: '12px', borderBottom: '2px solid #38bdf8', paddingBottom: '8px', display: 'inline-block' }}>
              4. Cookies & Session Management
            </h2>
            <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: 0 }}>
              We use functional cookies and local browser storage to keep you logged in, store your shopping bag items, and remember your account preferences.
            </p>
          </div>

          <div style={{ marginBottom: '0' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', marginTop: 0, marginBottom: '12px', borderBottom: '2px solid #38bdf8', paddingBottom: '8px', display: 'inline-block' }}>
              5. Contacting Privacy Officer
            </h2>
            <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: 0 }}>
              For data access requests or privacy inquiries, please contact our Privacy Team at <strong>privacy@honeycool.com</strong> or call <strong>1800-3000-2434</strong>.
            </p>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
